<template>
  <div>
    <div class="media">
      <media-player :issue="issue" :share="true" :header="true"></media-player>
    </div>
    <issue-authors v-bind:authors="issue.authors"></issue-authors>
    <div class="description">{{ issue.description }}</div>
    <div class="keywords" v-if="showKeywords">Keywords: <span>{{issue.keywords.join(', ')}}</span></div>
    <div class="article-quick-links">
      <article-quick-links :article="issue"></article-quick-links>
    </div>
  </div>
</template>

<script>
  import ArticleQuickLinks from '@/components/shared/ArticleQuickLinksComponent'
  import IssueAuthors from '@/components/shared/IssueAuthorsComponent'
  import MediaPlayer from '@/components/shared/MediaPlayerComponent'
  export default {
    name: 'full-video',
    props: ['issue', 'showKeywords'],
    components: {
      ArticleQuickLinks,
      IssueAuthors,
      MediaPlayer
    }
  }
</script>

<style lang="scss" scoped>
  .media {
    border: 1px solid #c0c0c0;
    position: relative;
    .media-wrapper {
      max-height: 402px;
      overflow-y: hidden;
    }
  }
  .description {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    line-height: 1.38;
    text-align: justify;
    color: $accent-color-3;
    margin-bottom: 23.5px;
  }
  .article-quick-links {
    margin-bottom: 58.5px;
  }
  .keywords {
    font-style: italic;
    font-size: 16px;
    margin: 20px 0px;
    span {
      color: $secondary-color;
    }
  }

</style>



// WEBPACK FOOTER //
// FullVideoComponent.vue?f3b80df2